import 'twin.macro';
import React from 'react';
import { CJEvent } from '@teetsh/app/src/types/event';
import { Classic } from './Classic';
import {
  BILAN_EVENT,
  BREAK_EVENT,
  CLASSIC_EVENT,
  RAPPEL_EVENT,
  RITUEL_EVENT,
} from '@teetsh/app/src/containers/constants';
import { BOLabels } from '@teetsh/app/src/types/user';
import Card from '@teetsh/app/src/components/Card';
import clsx from 'clsx';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';
import { Bilan } from 'containers/CahierJournal/DayColumn/Seance/Bilan';
import { useClickOnPreviewSeance, useIsSeancePreviewSelected } from '../atom';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';
import { useCJConfigurationDisplay } from 'containers/CahierJournal/useCJConfigurationDisplay';

interface Props {
  className?: string;
  event: CJEvent;
  boLabels: BOLabels;
  condensed: boolean;
  collapsed: boolean;
  classroomsOrg: ClassroomsOrg;
}

export function OneCard(props: Props) {
  const {
    className = '',
    event,
    boLabels,
    condensed,
    classroomsOrg,
    collapsed,
  } = props;
  const isSelected = useIsSeancePreviewSelected(event.id);
  const { t } = useTranslation(['cahierJournal']);
  const { density } = useCJConfigurationDisplay();

  const onClickPreviewSeance = useClickOnPreviewSeance();
  const { type } = event;
  if (type === 'loading') {
    return <div tw="w-full rounded h-16" className="tsh-skeleton" />;
  }
  return (
    <Card
      interactive
      css={[
        isSelected &&
          tw`bg-brand-moderate bg-opacity-20 border-primary hover:border-primary`,
        tw`p-0! flex-1 overflow-visible rounded-lg relative`,
      ]}
      className={clsx(className, 'group')}
      onClick={() => onClickPreviewSeance(event)}
    >
      {type === BILAN_EVENT && (
        <Bilan
          defaultTitle={t('cahierJournal:labels.bilan')}
          event={event}
          density={density}
        />
      )}
      {(type === CLASSIC_EVENT || type === RITUEL_EVENT) && (
        <Classic
          collapsed={collapsed}
          event={event}
          boLabels={boLabels}
          condensed={condensed}
          classroomsOrg={classroomsOrg}
        />
      )}
      {type === RAPPEL_EVENT && (
        <Bilan
          defaultTitle={t('cahierJournal:labels.reminders')}
          event={event}
          density={density}
        />
      )}
      {type === BREAK_EVENT && (
        <Classic
          collapsed={collapsed}
          event={event}
          boLabels={boLabels}
          condensed={condensed}
          classroomsOrg={classroomsOrg}
        />
      )}
    </Card>
  );
}
